module.exports = __webpack_public_path__ + "static/media/beetzmax-logo.cb8823bb.png";